import { Avatar } from "@mui/material";
import styles from "../orgListCard.module.scss";
import { bgColorbyName, organisationTypeColors } from "src/variable/randomColor";
import AdminSwitchOrg from "src/components/adminSwitchOrg/AdminSwitchOrg";
import { formatToRunningCase } from "src/utils";
import { DateStack } from "src/components/UI/transactionCells";
import { orgList } from "src/page/organisation/organisationSlice";
import OrgReferralRedirectLink from "src/components/orgReferralRedirectLink/OrgReferralRedirectLink";
import { EMPTY_STRING } from "src/components/constant/constant";
import { ShortIdChip } from "src/components/UI/shortIdChip/ShortIdChip";

const idColumn = {
  title: "Id",
  dataIndex: "organisationId",
  key: "organisationId",
  render: (organisationId: string) => (
    <ShortIdChip id={organisationId} leading={8} trailing={4} copiedLabel="ID Copied!" />
  )
};

const columns = (isInternalAdmin?: boolean) => [
  ...(isInternalAdmin ? [idColumn] : []),
  {
    title: "Display Id",
    dataIndex: "id",
    key: "id",
    render: (id: number) => (
      <ShortIdChip id={String(id)} withCopy copiedLabel="Display ID Copied!" />
    )
  },
  {
    title: "Company Name",
    dataIndex: "name",
    key: "name",
    render: (name: string, data: orgList) => (
      <div className={styles.tableMember}>
        <div className={styles.tableMemberImg}>
          <Avatar
            style={{ backgroundColor: bgColorbyName(name) }}
            sx={{ width: 32, height: 32, fontSize: "13px", fontWeight: 600, borderRadius: "8px" }}
          >
            {name?.charAt(0).toLocaleUpperCase()}
          </Avatar>
        </div>
        <div className={styles.tableMemberDetail}>
          <div className={styles.tableMemberName}>{name}</div>
          {data?.abn && <div className={styles.tableMemberEmail}>{data.abn}</div>}
        </div>
      </div>
    )
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    render: (type: string) => {
      if (!type) return <span>—</span>;
      const color = organisationTypeColors[type];

      return (
        <span
          className={styles.typeChip}
          style={color ? { background: `${color}1a`, borderColor: `${color}40`, color } : undefined}
        >
          {formatToRunningCase(type)}
        </span>
      );
    }
  },
  {
    title: "Referral Code",
    dataIndex: "referralCode",
    key: "referralCode",
    render: (referralCode: string) => <OrgReferralRedirectLink referralCode={referralCode} />
  },
  {
    title: "Date / Time",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (createdAt: string) => <DateStack value={createdAt} />
  },
  {
    title: "Name",
    dataIndex: "referenceName",
    key: "referenceName",
    render: (referenceName: string) => (
      <div className={styles.tableRole}>
        <div className={styles.tableRoleName}>{referenceName || "—"}</div>
      </div>
    )
  },
  {
    title: "Contact",
    dataIndex: "phone",
    key: "phone",
    render: (phone: string) => (
      <div className={styles.tableRole}>
        <div className={styles.tableRoleName}>{phone || "—"}</div>
      </div>
    )
  },
  {
    title: "Status",
    dataIndex: "active",
    key: "active",
    render: (active: boolean) => (
      <div className={styles.tableStatus}>
        <div className={active ? styles.green : styles.grey}>{active ? "Active" : "Archived"}</div>
      </div>
    )
  },
  {
    title: EMPTY_STRING,
    dataIndex: EMPTY_STRING,
    key: "operations",
    render: (data: { organisationId: string; active: boolean }) => {
      return data.active && <AdminSwitchOrg orgId={data.organisationId} />;
    }
  }
];

export default columns;
